import { benefitResource, BenefitResource } from '@witkac/kartamiejska-resources';
import { Benefit } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

export class BenefitModule extends EntityModule<Benefit, BenefitResource> {
  constructor() {
    super(benefitResource);

    this.actions = {
      ...this.actions,
      list: async (context: any, filters: any) => {
        const resp = await this.resource.list(filters);
        context.commit('saveList', resp.list);
        context.commit('saveCount', resp.count);
      },
      /**
       * Zatwierdza usługę
       *
       * @param {*} context
       * @param {number} id
       * @returns {Promise<void>}
       */
      confirm: async (context: any, id: number): Promise<void> => {
        await this.resource.confirm(id);
      },

      /**
       * Nadpisanie dodawania
       *
       * @param {*} context
       * @param {*} data
       * @returns {Promise<void>}
       */
      add: async (context: any, data: any, partners: any): Promise<void> => {
        const id = data.benefit.shared ? await this.resource.addShared(data) : await this.resource.add(data);
        const benefit = await context.dispatch('get', id);
        context.commit('add', benefit);
        context.commit('incrementCount');
      },

      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        if (data.benefit.shared) {
          await this.resource.updateShared(data.id, data);
        } else {
          await this.resource.update(data.id as number, data);
        }
        context.commit('update', data);
        await context.dispatch('get', data.id);
      },

      /**
       * Przypisanie wielu partnerów do usługi
       *
       * @param {*} context
       * @param {*} data
       * @returns {Promise<void>}
       */
      assign: async (context: any, data: any): Promise<void> => {
        const { partners } = (await this.resource.assignPartners(data.id, data.ids)) as any;
        const benefit = context.state.data;
        benefit.partners = partners;
        context.commit('update', benefit);
      }
    };
  }
}

export default new BenefitModule();
